import React from "react";

const ReadinessScore = ({ score = 95 }) => {
  let status = "🟢 Ready";
  let color = "text-green-600";

  if (score < 70) {
    status = "🔴 High Risk";
    color = "text-red-600";
  } else if (score < 90) {
    status = "🟡 Minor Risks";
    color = "text-yellow-600";
  }

  return (
    <div className="mt-6 border rounded-xl p-4 bg-gray-50">
      <h3 className="font-semibold text-lg mb-3">Site Readiness Score</h3>

      <div className="flex justify-between">
        <span>Score</span>
        <span className="font-semibold">{score}/100</span>
      </div>

      <div className="flex justify-between mt-2">
        <span>Status</span>
        <span className={`font-semibold ${color}`}>{status}</span>
      </div>
    </div>
  );
};

export default ReadinessScore;
